module.exports = __webpack_public_path__ + "assets/win-6538e4.mp3";